'use client';
import { anatomy } from '@zag-js/listbox';

const listboxAnatomy = anatomy.extendWith("empty");

export { listboxAnatomy };
